import { render, staticRenderFns } from "./EditFeatureModal.vue?vue&type=template&id=39b9c526&"
import script from "./EditFeatureModal.vue?vue&type=script&lang=js&"
export * from "./EditFeatureModal.vue?vue&type=script&lang=js&"
import style0 from "./EditFeatureModal.vue?vue&type=style&index=0&id=39b9c526&prod&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports